import React, { useEffect } from "react";

const TabbyWidget = ({ price, currency, lang }) => {
    useEffect(() => {
        const container = document.getElementById("tabby-promo-wrapper");

        if (container) {
            container.innerHTML = "";
        }

        if (window.TabbyPromo) {
            new window.TabbyPromo({
                selector: "#tabby-promo-wrapper",
                currency: currency,
                price: price,
                installmentsCount: 4,
                lang: lang,
                source: "product",
                publicKey: "pk_test_your_key",
            });
        }
    }, [price, currency, lang]);

    return (
        <div className="my-4 min-h-[80px]">
            <div id="tabby-promo-wrapper"></div>
        </div>
    );
};

export default TabbyWidget;
